import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

enum HydrationStatus {
  hydration_completed = 0,
  hydration_requested = 1,
  hydration_running = 2,
  hydration_failed = 3,
  hydration_triggered = 4,
}

@Model()
class SocialgistCaptureRule extends ApplicationRecord {
  static jsonapiType = "socialgist_capture_rules";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() externalId: string;

  @Attr() externalType: string;

  @Attr() hydrationStatus: HydrationStatus;

  @Attr() notes: string;

  @Attr() query: string;

  @Attr() signedUrl: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr({ persist: false }) verifiedAt: string;
}

export default SocialgistCaptureRule;
